export function isPlaceholderProductTitle(value) {
  const title = String(value || '').trim();
  if (!title) return true;
  return /^default(?:\s+title)?(?:\s*\(.+\))?$/i.test(title);
}

export function sanitizeProductTitleForDisplay(value, { sku } = {}) {
  const title = String(value || '').trim();
  if (!isPlaceholderProductTitle(title)) return title;
  const fallbackSku = String(sku || '').trim();
  return fallbackSku || '';
}

export function getDisplayVariantTitle(variantTitle, productTitle = '') {
  const title = String(variantTitle || '').trim();
  if (!title) return null;

  if (isPlaceholderProductTitle(title)) return null;

  const normalizedProductTitle = String(productTitle || '').trim().toLowerCase();
  if (normalizedProductTitle && title.toLowerCase() === normalizedProductTitle) return null;

  return title;
}
